import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/studios");
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: 'url("https://wallpaperaccess.com/full/84353.jpg")', // Replace with your background image
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: "#fff",
          fontWeight: 700,
          letterSpacing: 4,
          textShadow: "2px 2px 8px rgba(0,0,0,0.2)",
          mt: {xs:15, sm: 15, md: 15},
          fontFamily: "Josefin Sans", // Instagram-like font
          fontSize: { xs: "2.5rem", sm: "4rem", md: "5rem" },
          opacity: 1,
          ml:{xs:2, sm: 1, md: 0},
        }}
      >
        LC STUDIO MANAGEMENT
      </Typography>
    </Box>
  );
};

export default LandingPage;